import {MobileTHead} from '@/components/commons/table/mobile-t-head/MobileTHead'
import {TableProps} from '@components/commons/table/Table.tsx'
import {MobileTBody} from '@components/commons/table/mobile-t-body/MobileTBody'
import {StyledMobileTable} from '@/components/commons/table/mobile-table/style'

export const MobileTable = <TData extends unknown[], TSortName extends string | undefined>({
    columns,
    columnsMobile,
    data,
    isError,
    expandedRows,
    isChangingPage,
    isLoading,
    onChangePage,
    sorter,
    subRow
}: TableProps<TData, TSortName>) => {
    return (
        <StyledMobileTable>
            {sorter && <MobileTHead columns={columns} sorter={sorter} />}
            <MobileTBody
                columns={columnsMobile || columns}
                data={data}
                isError={isError}
                expandedRows={expandedRows}
                isChangingPage={isChangingPage}
                isLoading={isLoading}
                onChangePage={onChangePage}
                subRow={subRow}
            />
        </StyledMobileTable>
    )
}

MobileTable.displayName = 'MobileTable'
